// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"EventVenue_wrapper__zimlx","date":"EventVenue_date__5fyZK"};